import { Expression } from 'pages/GatewayRules/components/GatewayRulesForm/GatewayRulesForm';
import { useExpressionParamWithData } from 'pages/GatewayRules/hooks';
import { ExpressionParam } from 'types/embedded/gatewayRule';

type UseInitialExpressionResult = {
  initialExpression: Expression;
  isLoading: boolean;
};

export function useInitialExpression(
  expressionParams: ExpressionParam[],
): UseInitialExpressionResult {
  const expressionParam = expressionParams[0];
  const { expressionParamWithData, loadingExpressionParamWithData } = useExpressionParamWithData(
    expressionParam?.alias,
  );

  const initialExpression: Expression = {
    expressionParam,
    comparisonOperator: expressionParamWithData?.comparisonOperators[0],
    value: [],
  };

  return {
    initialExpression,
    isLoading: loadingExpressionParamWithData,
  };
}
